import { attr, belongsTo } from 'spraypaint';
import BaseApplicationRecord from './ApplicationRecord';

const LeadTimeSchedule = BaseApplicationRecord.extend({
  attrs: {
    dispatch_weekday: attr(),
    goods_in_days_before_dispatch: attr(),
    order_days_before_dispatch: attr(),
    order_time: attr(),
    supplier: belongsTo({ type: 'suppliers-suppliers', persist: false }),
  },
  static: {
    jsonapiType: 'suppliers-lead_time_schedules',
  },
});

export default LeadTimeSchedule;
